import React, { useState, useEffect } from "react";
import { Row, Col, Form, Card, CardBody } from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";

import config from "../../utils/config";
import get from "lodash/get";
import Loader from "../Loader";
import moment from "moment";
import { useSelector } from "react-redux";

const _ = { get };

export default function PartnerPreviewPage(props) {
  const [region, setRegion] = useState([]);
  const { elements } = useSelector((state) => state.Elements);
  const handleGoBack = () => {
    props.handleToggleModel();
  };

  const handleServices = (data) => {
    let dataArray = [];
    for (let i = 0; i < data.length; i++) {
      dataArray.push(data[i].value);
    }
    return dataArray;
  };

  useEffect(() => {
    if (props && props.partnerDetailsData) {
      var names = props.partnerDetailsData.region.map(function(item) {
        return item["value"];
      });
      setRegion(names);
    }
  }, [props]);
  return (
    <React.Fragment>
      {console.log(
        "da",
        props &&
          props.partnerDetailsData &&
          props.partnerDetailsData.region.toString()
      )}
      <div className="hideSearch mt-4">
        {!props.partnerDetailsData && <Loader />}
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "euToursElement.partnerPersonalPreviewInfoElement.headingElement",
                  "Partner Personal Information"
                )}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col xl={3} lg={12} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.businessNameElement",
                      "Business Name"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.name
                        ? props.partnerDetailsData.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={12} lg={12} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.shortBioElement",
                      "Short Bio (Profile) of your Business"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.bio
                        ? props.partnerDetailsData.bio
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.emailElement",
                      "Email"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.email
                        ? props.partnerDetailsData.email
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.contactNumberElement",
                      "Contact Number"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.primaryCallingCode &&
                      props.partnerDetailsData.primaryNumber
                        ? `${props.partnerDetailsData.primaryCallingCode}${props.partnerDetailsData.primaryNumber}`
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.alternativeNumberElement",
                      "Alternative Contact Number"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.secondaryCallingCode &&
                      props.partnerDetailsData.secondaryNumber
                        ? `${props.partnerDetailsData.secondaryCallingCode}${props.partnerDetailsData.secondaryNumber}`
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.websiteElement",
                      "Website"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.website
                        ? props.partnerDetailsData.website
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.instagramElement",
                      "Instagram"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.instagram
                        ? props.partnerDetailsData.instagram
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.regionRating",
                      "Partner Rating"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.regionRating
                        ? props.partnerDetailsData.regionRating
                        : "N/A"
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.thumbnailImageLandingPageElement",
                      "Landing Page Filter Thumbnail (160 x 190 px)"
                    )}
                  </div>
                  {props &&
                  props.partnerDetailsData &&
                  props.partnerDetailsData.thumbnailImage ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.partnerDetailsData &&
                        props.partnerDetailsData.thumbnailImage}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.thumbnailImageListingPageElement",
                      "Partner Listing Page Thumbnail - Desktop (450 x 380 px)"
                    )}
                  </div>
                  {props &&
                  props.partnerDetailsData &&
                  props.partnerDetailsData.thumbnailListingDesktop ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.partnerDetailsData &&
                        props.partnerDetailsData.thumbnailListingDesktop}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.thumbnailImageListingPageMobileElement",
                      "Partner Listing Page Thumbnail - Mobile (400 x 200 px)"
                    )}
                  </div>
                  {props &&
                  props.partnerDetailsData &&
                  props.partnerDetailsData.thumbnailListingMobile ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.partnerDetailsData &&
                        props.partnerDetailsData.thumbnailListingMobile}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.thumbnailImageDetailPageElement",
                      "Partner Detail Page - Top Banner - Desktop - (1920 x 620 px)"
                    )}
                  </div>
                  {props &&
                  props.partnerDetailsData &&
                  props.partnerDetailsData.thumbnailDetailDesktop ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.partnerDetailsData &&
                        props.partnerDetailsData.thumbnailDetailDesktop}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.thumbnailImageDetailPageMobileElement",
                      "Partner Detail Page - Top Banner - Mobile - (450 x 800 px)"
                    )}
                  </div>
                  {props &&
                  props.partnerDetailsData &&
                  props.partnerDetailsData.thumbnailDetailMobile ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.partnerDetailsData &&
                        props.partnerDetailsData.thumbnailDetailMobile}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}{" "}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.thumbnailImageBottomBannerDesktopElement",
                      "Partner Detail Page- Bottom Banner - Desktop - (1920 x 600 px)"
                    )}
                  </div>
                  {props &&
                  props.partnerDetailsData &&
                  props.partnerDetailsData.thumbnailDetailBannerDesktop ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.partnerDetailsData &&
                        props.partnerDetailsData.thumbnailDetailBannerDesktop}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.thumbnailImageBottomBannerMobileElement",
                      "Partner Detail Page- Bottom Banner - Mobile - (450 x 480 px)"
                    )}
                  </div>
                  {props &&
                  props.partnerDetailsData &&
                  props.partnerDetailsData.thumbnailDetailBannerMobile ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props &&
                        props.partnerDetailsData &&
                        props.partnerDetailsData.thumbnailDetailBannerMobile}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
              </Row>
              <Row>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.countryWhereBusinessOperatesElement",
                      "Country where business operates"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.country
                        ? props.partnerDetailsData.country
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.countryOfferServices",
                      "Countries where you offer your services"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.servicesOfferCounties &&
                      props.partnerDetailsData.servicesOfferCounties.length > 0
                        ? handleServices(
                            props.partnerDetailsData.servicesOfferCounties
                          ).toString()
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.businessEstablishedYear",
                      "Year your Business was established"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.establishYear
                        ? moment(props.partnerDetailsData.establishYear).format(
                            "YYYY"
                          )
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.reMotercycleFleet",
                      "Which RE motorcycles model do you have within your fleet? (Multiple)"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.motorcycleModels &&
                      props.partnerDetailsData.motorcycleModels.length > 0
                        ? handleServices(
                            props.partnerDetailsData.motorcycleModels
                          ).toString()
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.nonGuidedTourElement",
                      "Do you offer motorcycle rental for non-guided tours?"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.offerMotorcycle &&
                      props.partnerDetailsData.offerMotorcycle === true
                        ? "Yes"
                        : "No"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.guidedToursOfferedElement",
                      "Guided tours offered"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.guidedTours &&
                      props.partnerDetailsData.guidedTours === true
                        ? "Yes"
                        : "No"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.selfRentalsElement",
                      "Self rentals options"
                    )}
                    titleName={
                      props &&
                      props.partnerDetailsData &&
                      props.partnerDetailsData.selfRental &&
                      props.partnerDetailsData.selfRental === true
                        ? "Yes"
                        : "No"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.regionElement",
                      "Region"
                    )}
                    titleName={region ? region.toString() : "N/A"}
                  />
                </Col>
                <Col xl={12} className="mb-4 mt-3 ml-2">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.galleryImages",
                      "Gallery Common"
                    )}
                  </div>
                </Col>
                <Col xl={12}>
                  <Row>
                    {props &&
                    props.partnerDetailsData &&
                    props.partnerDetailsData.images && props.partnerDetailsData.images.length > 0 ? (
                      props.partnerDetailsData.images.map((item) => (
                        <Col
                          xl={2}
                          lg={2}
                          md={3}
                          sm={3}
                          className="mb-3 image-tour_main "
                        >
                          <div>
                            <img
                              className="image_tour2"
                              src={`${config.imageBaseUrl}/${item}`}
                              alt="img"
                            />
                          </div>
                        </Col>
                      ))
                    ) : (
                      <Col xl={12} className="ml-2">
                        {" "}
                        N/A
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalPreviewInfoElement.thumbnailImageVideoPosterElement",
                      "Thumbnail - Partner Detail - Video Poster Image - (1920 x600 px) "
                    )}
                  </div>
                  {props &&
                  props.partnerDetailsData &&
                  props.partnerDetailsData.thumbnailVideo ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${props.partnerDetailsData &&
                        props.partnerDetailsData.thumbnailVideo}
                    `}
                      alt="img"
                    />
                  ) : (
                    "N/A"
                  )}
                </Col>
                {props &&
                  props.partnerDetailsData &&
                  props.partnerDetailsData.video && (
                    <Col xl={12} className="mb-4 mt-3 ml-2">
                      <div className="personal_tour_image mb-3">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalPreviewInfoElement.videoElement",
                          "Video"
                        )}
                      </div>
                      <Row>
                        {props &&
                        props.partnerDetailsData &&
                        props.partnerDetailsData.video ? (
                          <Col xl={3} lg={3} md={6} sm={12}>
                            <video
                              // className="img-fluid"
                              width="100%"
                              height="230px"
                              controls
                            >
                              <source
                                src={`${config.imageBaseUrl}/${props &&
                                  props.partnerDetailsData &&
                                  props.partnerDetailsData.video}`}
                                type="video/mp4"
                              ></source>
                            </video>
                          </Col>
                        ) : (
                          <Col xl={3} lg={3} md={6} sm={12}>
                            N/A
                          </Col>
                        )}
                      </Row>
                    </Col>
                  )}
              </Row>
              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5">
                <CustomButton
                  customType={"button"}
                  name="Back"
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() => handleGoBack()}
                />
              </div>
            </CardBody>
          </Card>
        </Form>
      </div>
    </React.Fragment>
  );
}
